import { createReducer } from '../../helpers/reducer-helper';
import { SET_PASSENGERS_REDIRECT, CLOSE_REDIRECT_POPUP } from '../constants/actions';
const initialState = {
  passengers: null,
  on: null,
  showed: false
};
export default createReducer({
  [SET_PASSENGERS_REDIRECT](state, {
    passengers
  }) {
    return {
      ...state,
      passengers
    };
  },
  [CLOSE_REDIRECT_POPUP]() {
    return initialState;
  }
}, initialState);